import React from 'react';

import RowBar from 'components/application/RowBar';

const rowCount = 6;

export default function PendingBars() {
  return [...Array(rowCount)].map((_, index) => (
    <RowBar
      content={
        <div className='tw-flex tw-animate-pulse tw-items-center tw-gap-3'>
          <div className='tw-h-3 tw-w-45 tw-rounded-lg tw-bg-grey-100' />
          <div className='tw-h-3 tw-w-33 tw-rounded-lg tw-bg-grey-100' />
        </div>
      }
      key={`pendingRow--${index}`}
    />
  ));
}
